import ComicContent from "./ComicContent";
import ComicNav from "./ComicNav";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {comicNewsGet} from "../actions";
import NewsItem from "./NewsItem";
import ComicList from "../ComicList";
import CommentsContainer from "./CommentsContainer";
import LoadingIndicator from "./LoadingIndicator";
import {useTitle} from "../useTitle";

let ComicContainer = ( {story} ) => {
  const { comic, char } = useParams();
  const [ showComments, setShowComments ] = useState({});

  const stories = useSelector(state => state.stories);
  const comicList = new ComicList(stories.comics[story]);
  const comicNumber = comicList.validComicNumber(comic, char);

  const newsItem = useSelector(state => state.comicNews[story][comicNumber]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!newsItem) {
      dispatch(comicNewsGet({ story, id: comicNumber })).catch(() => {});
    }
  });

  let commentsHandler = () => setShowComments({
    ...showComments, [comic]: !showComments[comic]
  });
  let addCommentHandler = () => setShowComments({
    ...showComments, [comic]: true
  });

  useTitle((char ? `${char.replace(/^(\w)/, l => l.toUpperCase())} - ` : '') + comic);

  return (
    <div className={`comic_${story}`}>
      <ComicNav story={story} char={char} comic={comic} />
      <ComicContent story={story} char={char} comic={comic} />
      <ComicNav story={story} char={char} comic={comic} />
      <LoadingIndicator isLoading={!newsItem || newsItem.loading} />
      <NewsItem newsItem={newsItem} commentsHandler={commentsHandler} addCommentHandler={addCommentHandler}/>
      { (!showComments[comic] || !newsItem || !newsItem.id) ? null :
        <CommentsContainer newsId={ newsItem.id } />
      }
    </div>
  );
};

export default ComicContainer;